import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormHelperText,
  Grid2,
  IconButton,
  TextField,
  useTheme,
} from "@mui/material";
import { Formik } from "formik";
import * as React from "react";
import { IoMdClose } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import { useUpdateFileUploadMutation } from "store/slices/apis/fileUploadSlice";
import * as Yup from "yup";

export default function RejectFileComponentent(props) {
  const { open, cancel, rowData, openNotification, refetch } = props;
  const theme = useTheme();
  const navigate = useNavigate();
  const { projectId } = useParams();
  const [updateFile, updateFileRes] = useUpdateFileUploadMutation();
  const [formData, setFormData] = React.useState({
    Comment: "",
    Status: "Reject",
  });
  const handleSubmit = (values) => {
    updateFile({ ...values, Id: rowData?.id });
  };

  React.useEffect(() => {
    if (updateFileRes?.isSuccess) {
      if (updateFileRes?.data?.status == "success") {
        openNotification(updateFileRes?.data?.message, "success");
        cancel();
        refetch();
        navigate(`/projects/${projectId}/key-file/file-submitted-by-me`);
      } else {
        openNotification(updateFileRes?.data?.message, "error");
      }
    }
  }, [updateFileRes?.isSuccess]);

  const validationSchema = Yup.object({
    Comment: Yup.string().required("Comment field is required."),
  });

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={cancel}
        disableEnforceFocus
        disableRestoreFocus
        aria-labelledby="draggable-dialog-title"
        fullWidth={true}
        maxWidth={"sm"}
      >
        <DialogTitle
          sx={{
            fontWeight: 500,
            fontSize: "20px",
            color: "#252525",
            paddingBottom: 0,
          }}
          id="draggable-dialog-title"
        >
          Reject
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={cancel}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <IoMdClose style={{ fontSize: "20px" }} />
        </IconButton>
        <DialogContent>
          <DialogContentText
            sx={{ fontWeight: 400, fontSize: "16px", color: "#474747" }}
          >
            <Formik
              initialValues={formData}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
                setTouched,
              }) => (
                <form onSubmit={handleSubmit}>
                  <Grid2 size={12}>
                    <DialogContentText
                      sx={{
                        fontWeight: 400,
                        fontSize: "16px",
                        color: "#474747",
                        marginBottom: "20px",
                      }}
                    >
                      Are you sure you want to reject this request? This action
                      is permanent.
                    </DialogContentText>
                    <TextField
                      id="outlined-multiline-static"
                      label="Comment"
                      name="Comment"
                      multiline
                      fullWidth
                      value={values?.Comment}
                      onChange={handleChange}
                      onBlur={() => setTouched({ ...touched, Comment: true })}
                      slotProps={{ inputLabel: { shrink: true } }}
                      variant="filled"
                    />
                    {touched?.Comment && errors?.Comment && (
                      <FormHelperText
                        sx={{ color: "#C52A1A", fontSize: "12px" }}
                      >{`${errors?.Comment}`}</FormHelperText>
                    )}
                  </Grid2>

                  <Grid2 size={12}>
                    <DialogActions>
                      {/* <Button variant="outlined" onClick={cancel} sx={{
                                                color: '#415385',
                                                fontSize: '16px',
                                                fontWeight: '500',
                                                textTransform: 'none',
                                                border: '1px solid #415385'
                                            }}>Cancel</Button> */}
                      <Button
                        type="submit"
                        loading={updateFileRes?.isLoading}
                        variant="contained"
                        sx={{
                          backgroundColor: "#C52A1A",
                          color: "#fff",
                          fontSize: "16px",
                          fontWeight: "500",
                          textTransform: "none",
                        }}
                      >
                        Reject
                      </Button>
                    </DialogActions>
                  </Grid2>
                </form>
              )}
            </Formik>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
